import type { ReactNode } from "react";

interface OriginalDialogProps {
  readonly title: string;
  readonly children: ReactNode;
  readonly onClose: () => void;
  readonly wide?: boolean;
}

export const OriginalDialog = ({ title, children, onClose, wide = false }: OriginalDialogProps) => (
  <div className="dialog-backdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
    <section className={`original-dialog${wide ? " original-dialog--wide" : ""}`} role="dialog" aria-modal="true" aria-label={title}>
      <h2>{title}</h2>
      <button type="button" className="dialog-close" onClick={onClose} aria-label="Close">×</button>
      <div className="dialog-content">{children}</div>
    </section>
  </div>
);
